import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./Main.module.scss";
import altIcon from "../../imgs/altIcon.svg";
import { useTranslation } from "react-i18next";
import OrdersTable from "../../components/OrdersTable";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import Graph from "../../components/Graph";
import { Drawer } from "@mui/material";
import BuySellDrawer from "../../components/BuySellDrawer";
import MobileAssetsDrawer from "../../components/MobileAssetsDrawer";
import moment from "moment";
import MobileOrderDrawer from "../../components/MobileOrderDrawer";
import EditOrderDrawer from "../../components/EditOrderDrawer";
import AssetsListComponent from "../../components/AssetsList.jsx";
import { useAppDispatch, useAppSelector } from "../../redux/store.ts";
import { setOrderButtonAction } from "../../redux/slices/rootSlice.ts";
import OrdersTableHistory from "../../components/OrdersTableHistory.jsx";
import assetsLogo from "../../components/assetsLogo.json";

export default function Main({
  activeAsset,
  activePrice,
  setActivePrice,
  setActiveAsset,
  theme,
  eurToUsd,
  usdToEur,
  favorites,
  toggleFavorite,
  AssetsList,
  account,
  setAccount,
  setProfit,
  setSnackType,
  setSnackMessage,
  handleClick,
  applications,
}) {
  const dispatch = useAppDispatch();
  const orderButtonIsPressed = useAppSelector(
    (state) => state.root.orderButtonIsPressed
  );
  const handlePressButton = () => {
    dispatch(setOrderButtonAction(!orderButtonIsPressed));
  };

  const handleImgError = (e) => {
    e.target.src = altIcon;
  };
  const { t, i18n } = useTranslation();
  const [currentRecords, setCurrentRecords] = useState([]);
  const [currentAssets, setCurrentAssets] = useState([]);
  const [history, setHistory] = useState([]);
  const [interval, setInterval] = useState(60);
  const [intervalLabel, setIntervalLabel] = useState("1m");
  const [openAssetsDrawer, setOpenAssetsDrawer] = useState(false);

  const toggleAssetsDrawer = (newOpen) => () => {
    setOpenAssetsDrawer(newOpen);
  };

  const handleIntervalChange = (newInterval, label) => {
    setInterval(newInterval);
    setIntervalLabel(label);
  };
  const [currentRow, setCurrentRow] = useState({});
  const [openEditDrawer, setOpenEditOrder] = useState(false);
  const [selectedTab, setSelectedTab] = useState("open");
  const [selectedMobileTab, setSelectedMobileTab] = useState("open");
  const [selectedIntervalTab, setSelectedIntervalTab] = useState("1m");
  const [backgroundTableStyle, setBackgroundTableStyle] = useState({});
  const [backgroundMobileStyle, setBackgroundMobileStyle] = useState({});
  const [backgroundIntervalStyle, setBackgroundIntervalStyle] = useState({});
  const [backgroundTradingStyle, setBackgroundTradingStyle] = useState({});
  const openMobile = useRef(null);
  const deferredMobile = useRef(null);
  const closeMobile = useRef(null);
  const open = useRef(null);
  const deferred = useRef(null);
  const close = useRef(null);
  const min = useRef(null);
  const fivemin = useRef(null);
  const fifteenmin = useRef(null);
  const thirtymin = useRef(null);
  const hour = useRef(null);
  const fourhour = useRef(null);
  const day = useRef(null);
  const week = useRef(null);
  const month = useRef(null);
  const trading = useRef(null);
  const orders = useRef(null);
  const [selectedOrderTab, setSelectedOrderTab] = useState("buy");
  const [selectedTradingTab, setSelectedTradingTab] = useState("trading");
  const [backgroundOrderStyle, setBackgroundOrderStyle] = useState({});
  const buyOrder = useRef(null);
  const sellOrder = useRef(null);
  const inputRef = useRef(null);

  const toggleEditDrawer = (newOpen, element) => () => {
    setOpenEditOrder(newOpen);
    setCurrentRow(element);
  };

  const handleSearchClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleTabTableChange = (tab) => {
    setSelectedTab(tab);
  };
  const handleTabMobileChange = (tab) => {
    setSelectedMobileTab(tab);
  };

  const updateBackgroundPositionMobile = () => {
    let targetTab;
    switch (selectedMobileTab) {
      case "open":
        targetTab = openMobile.current;
        break;
      case "deferred":
        targetTab = deferredMobile.current;
        break;
      case "close":
        targetTab = closeMobile.current;
        break;
      default:
        targetTab = openMobile.current;
    }

    if (targetTab) {
      setBackgroundMobileStyle({
        width: targetTab.offsetWidth,
        height: targetTab.offsetHeight,
        transform: `translateX(${targetTab.offsetLeft - 3}px)`,
        transition: "background-color 0.3s ease, transform 0.3s ease", // Добавляем анимацию
      });
    }
  };
  useEffect(() => {
    updateBackgroundPositionMobile();
  }, [selectedMobileTab]);

  const handleTabOrderChange = (tab) => {
    setSelectedOrderTab(tab);
  };

  const handleTabIntervalChange = (tab) => {
    setSelectedIntervalTab(tab);
  };
  const handleTabTradingChange = (tab) => {
    setSelectedTradingTab(tab);
  };
  const updateBackgroundPositionInterval = () => {
    let targetTab;
    switch (selectedIntervalTab) {
      case "1m":
        targetTab = min.current;
        break;
      case "5m":
        targetTab = fivemin.current;
        break;
      case "15m":
        targetTab = fifteenmin.current;
        break;
      case "30m":
        targetTab = thirtymin.current;
        break;
      case "1h":
        targetTab = hour.current;
        break;
      case "4h":
        targetTab = fourhour.current;
        break;
      case "1d":
        targetTab = day.current;
        break;
      case "1w":
        targetTab = week.current;
        break;
      case "1M":
        targetTab = month.current;
        break;
      default:
        targetTab = min.current;
    }

    if (targetTab) {
      setBackgroundIntervalStyle({
        width: targetTab.offsetWidth,
        height: targetTab.offsetHeight,
        transform: `translateX(${targetTab.offsetLeft - 3}px)`,
        transition: "background-color 0.3s ease, transform 0.3s ease", // Добавляем анимацию
      });
    }
  };
  const updateBackgroundPositionTrading = () => {
    let targetTab;
    switch (selectedTradingTab) {
      case "trading":
        targetTab = trading.current;
        break;
      case "orders":
        targetTab = orders.current;
        break;
      default:
        targetTab = trading.current;
    }

    if (targetTab) {
      setBackgroundTradingStyle({
        width: targetTab.offsetWidth,
        height: targetTab.offsetHeight,
        transform: `translateX(${targetTab.offsetLeft - 3}px)`,
        transition: "background-color 0.3s ease, transform 0.3s ease", // Добавляем анимацию
      });
    }
  };
  useEffect(() => {
    updateBackgroundPositionTrading();
  }, [selectedTradingTab]);
  useEffect(() => {
    updateBackgroundPositionInterval();
  }, [selectedIntervalTab]);

  const updateBackgroundPositionTable = () => {
    let targetTab;
    switch (selectedTab) {
      case "open":
        targetTab = open.current;
        break;
      case "deferred":
        targetTab = deferred.current;
        break;
      case "close":
        targetTab = close.current;
        break;
      default:
        targetTab = open.current;
    }

    // if (targetTab) {
    //   setBackgroundTableStyle({
    //     width: targetTab.offsetWidth,
    //     height: targetTab.offsetHeight,
    //     transform: `translateX(${targetTab.offsetLeft - 3}px)`,
    //     transition: "background-color 0.3s ease, transform 0.3s ease",
    //     backgroundColor: "var(--background-2, #242529)",
    //   });
    // }
  };
  useEffect(() => {
    updateBackgroundPositionTable();
  }, [selectedTab]);

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_test_url +
          `/api/account/assets/user/${account?.Id}/history`,
        {
          headers: {
            Authorization: "Bearer " + secureLocalStorage.getItem("token"),
          },
        }
      )
      .then((result) => {
        setHistory(
          result.data.filter(
            (el) => el.Status == "CLOSED" || el.Status == "KILLED"
          )
        );
      })
      .catch((e) => console.log(e));
    const timer = setInterval(() => {
      axios
        .get(
          process.env.REACT_APP_test_url +
            `/api/account/assets/user/${account?.Id}/history`,
          {
            headers: {
              Authorization: "Bearer " + secureLocalStorage.getItem("token"),
            },
          }
        )
        .then((result) => {
          setHistory(
            result.data.filter(
              (el) => el.Status == "CLOSED" || el.Status == "KILLED"
            )
          );
        })
        .catch((e) => console.log(e));
      axios
        .get(
          process.env.REACT_APP_test_url +
            `/api/account/assets/user/${account?.Id}`,
          {
            headers: {
              Authorization: "Bearer " + secureLocalStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          setCurrentRecords(res.data.reverse());
        })
        .catch((err) => {
          console.log(err);
        });
      const FetchList = async () => {
        try {
          const res = await axios.get(
            process.env.REACT_APP_test_url + "/api/assets",
            {
              headers: {
                Authorization: `Bearer ${secureLocalStorage.getItem("token")}`,
              },
            }
          );
          setCurrentAssets(res.data);
        } catch (e) {
          console.log(e);
        }
      };
      FetchList();
    }, 2000);
    return () => {
      clearInterval(timer);
    };
  }, [account]);
  const Close = async (row) => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_test_url +
          `/api/account/assets/${row.AssetId}/close`,
        {
          user_id: account?.Id,
          asset_id: row.Id,
        },
        {
          headers: {
            Authorization: `Bearer ${secureLocalStorage.getItem("token")}`,
          },
        }
      );
      if (data) {
        handleClick();
        setSnackMessage(
          `${t("CloseSuccess")} ${
            row.OpenWhen
              ? ""
              : t("Profit") +
                ": " +
                parseFloat(row.Profit).toFixed(2) +
                `${
                  secureLocalStorage.getItem("selected_account")
                    ?.AccountCurrency === "EUR"
                    ? "€"
                    : "$"
                }`
          }`
        );
        setSnackType("success");
      }
    } catch (e) {
      handleClick();
      setSnackMessage(e.response.data.message);
      setSnackType("error");
    }
  };

  const getLiquidationPrice = (row) => {
    const user = secureLocalStorage.getItem("user");
    const currency = account?.AccountCurrency || "USD"; // Предполагаем, что по умолчанию USD
    const currencyFactor = currency === "EUR" ? eurToUsd : 1;
    const symbol = currency === "EUR" ? "€" : "$";

    const startPrice = parseFloat(row.original.StartPrice) * currencyFactor;
    const leverage = parseFloat(row.original.Leverage);
    // Если кредитное плечо равно 1, ликвидационная цена не применяется
    if (leverage === 1 || row.original.StopLoss) {
      return "-- --";
    }

    let liquidationPrice;

    if (row.original.Status === "BUY") {
      // Формула для длинной позиции (BUY)
      liquidationPrice = startPrice * (1 - 1 / leverage);
    } else {
      // Формула для короткой позиции (SELL)
      liquidationPrice = startPrice * (1 + 1 / leverage);
    }

    // Форматируем результат до 4 знаков после запятой
    return `${liquidationPrice.toFixed(4)} ${symbol}`;
  };

  const Sell = async (row) => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_test_url +
          `/api/account/assets/${row.AssetId}/close/deffered`,
        {
          user_id: account?.Id,
          asset_id: row.Id,
          eurToUsd: eurToUsd,
          usdToEur: usdToEur,
        },
        {
          headers: {
            Authorization: `Bearer ${secureLocalStorage.getItem("token")}`,
          },
        }
      );
      if (data) {
        console.log("success");
      }
    } catch (e) {
      handleClick();
      setSnackMessage(e.response.data.message);
      setSnackType("error");
    }
  };
  const columns = useMemo(
    () => [
      {
        accessorKey: "Id",
        header: t("OrderId"),
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("OrderId")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        grow: 1,
        size: 40,
      },
      {
        accessorKey: "TimeInForceDate",
        header: t("Open Date"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Open Date")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span>
              {moment(row.original.TimeInForceDate).format("YYYY-MM-DD")}
              <span style={{ color: theme === "dark" ? "#51525C" : "#9CA3AF" }}>
                {" "}
                {moment(row.original.TimeInForceDate).format("HH:mm")}
              </span>
            </span>
          );
        },
      },
      {
        accessorKey: "Title",
        header: t("Instrument"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Instrument")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span style={{ cursor: "pointer" }}>
              {account?.AccountCurrency == "EUR"
                ? row.original.Subtitle.slice(1, -1).replace("/USD", "/EUR")
                : row.original.Subtitle.slice(1, -1)}
            </span>
          );
        },
      },
      {
        accessorKey: "Status",
        header: t("Type"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Type")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span
              style={
                row.original.Status === "BUY"
                  ? {
                      color: "#00B4A0",
                      backgroundColor: "rgba(0, 180, 160, 0.08)",
                      padding: "0.4vh 1.2vh",
                      borderRadius: "100px",
                    }
                  : row.original.Status === "SELL"
                  ? {
                      color: "#4C47A2",
                      backgroundColor: "rgba(246, 61, 104, 0.08)",
                      padding: "0.4vh 1.2vh",
                      borderRadius: "100px",
                    }
                  : {}
              }
            >
              {row.original.Status.slice(0, 1) +
                row.original.Status.slice(1).toLowerCase()}
            </span>
          );
        },
      },
      {
        accessorKey: "Leverage",
        header: t("Leverage"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Leverage")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span
              style={{
                backgroundColor: "rgba(233, 119, 14, 0.08)",
                color: "#E9770E",
                padding: "0.4vh 1.2vh",
                borderRadius: "100px",
              }}
            >
              X{row.original.Leverage}
            </span>
          );
        },
      },
      {
        accessorKey: "Price",
        header: t("Margin"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Margin")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span>
              {account?.AccountCurrency == "EUR" ? "€" : "$"}
              {(
                row.original.Price *
                (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
              )?.toFixed(5)}
            </span>
          );
        },
      },
      {
        accessorKey: "StartPrice",
        header: t("EntryPrice"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("EntryPrice")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span>
              {account?.AccountCurrency == "EUR" ? "€" : "$"}
              {(
                row.original.StartPrice *
                (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
              )?.toFixed(5)}
            </span>
          );
        },
      },
      {
        accessorKey: "Take",
        header: t("Take-Profit"),
        grow: 1,
        size: 40,
        enableSorting: false,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Take-Profit")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={toggleEditDrawer(true, row.original)}
            >
              <span style={{ fontSize: "1.2vh", color: "#3F3F46" }}>
                {row.original.TakeProfit ? (
                  <span style={{ color: "#00B4A0" }}>
                    {(
                      row.original.TakeProfit *
                      (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                    ).toFixed(4)}
                    {account?.AccountCurrency == "EUR" ? "€" : "$"}
                  </span>
                ) : (
                  <span style={{ color: "#00B4A0" }}>
                    0 {account?.AccountCurrency == "EUR" ? "€" : "$"}
                  </span>
                )}
              </span>
            </span>
          );
        },
      },
      {
        accessorKey: "Stop",
        header: t("Stop-Loss"),
        grow: 1,
        size: 40,
        enableSorting: false,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Stop-Loss")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={toggleEditDrawer(true, row.original)}
            >
              <span style={{ fontSize: "1.2vh", color: "#3F3F46" }}>
                {row.original.StopLoss ? (
                  <span style={{ color: "#4C47A2" }}>
                    {(
                      row.original.StopLoss *
                      (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                    ).toFixed(4)}
                    {account?.AccountCurrency == "EUR" ? "€" : "$"}
                  </span>
                ) : (
                  <span style={{ color: "#4C47A2" }}>
                    0 {account?.AccountCurrency == "EUR" ? "€" : "$"}
                  </span>
                )}
              </span>
            </span>
          );
        },
      },
      {
        accessorKey: "Liquidation",
        header: t("Liquidation"),
        grow: 1,
        size: 40,

        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Liquidation")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span
              style={
                row.original.Leverage == 1 || row.original.StopLoss
                  ? { color: "#9F9C9C" }
                  : { color: "#4C47A2" }
              }
            >
              {getLiquidationPrice(row)}
            </span>
          );
        },
      },
      // {
      //     accessorKey: 'Market',
      //     header: t('MarketPrice'),
      //     grow: 1,
      //     size: 40,
      //     Header: () => (
      //         <div className={styles.header_cell}>
      //             <span style={{ fontWeight: '500', lineHeight: '1.6vh' }} className={styles.header_name}>{t('MarketPrice')}</span>
      //             <div className={styles.sort_icon}>
      //                 <svg xmlns="http://www.w3.org/2000/svg" width={"0.8vh"} height={"0.5vh"} viewBox="0 0 8 5" fill="none">
      //                     <path d="M1 4L4 1L7 4" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      //                 </svg>
      //                 <svg xmlns="http://www.w3.org/2000/svg" width={"0.8vh"} height={"0.5vh"} viewBox="0 0 8 5" fill="none">
      //                     <path d="M7 1L4 4L1 1" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      //                 </svg>
      //             </div>
      //         </div>
      //     ),
      //     Cell: ({ row }) => {
      //         return (
      //             <span>
      //                 {
      //                     account?.AccountCurrency == "EUR"
      //                         ?
      //                         "€"
      //                         :
      //                         "$"
      //                 }
      //                 {(parseFloat(row.original.MarketPrice * (account?.AccountCurrency == "EUR" ? eurToUsd : 1))).toFixed(4)}
      //             </span>
      //         )
      //     },
      // },
      {
        accessorKey: "Profit",
        header: t("Profit"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Profit")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span>
              {row.original.Status === "BUY" ? (
                <div
                  style={
                    parseFloat(row.original.Profit) > 0
                      ? { color: "#00B4A0" }
                      : { color: "#4C47A2" }
                  }
                >
                  {parseFloat(row.original.Profit) > 0 ? "+ " : "- "}
                  {account?.AccountCurrency == "EUR" ? "€" : "$"}
                  {parseFloat(row.original.Profit) > 0
                    ? parseFloat(
                        row.original.Profit *
                          (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                      ).toFixed(1)
                    : parseFloat(
                        row.original.Profit *
                          (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                      )
                        .toFixed(1)
                        .slice(1)}
                </div>
              ) : (
                <div
                  style={
                    parseFloat(row.original.Profit) > 0
                      ? { color: "#00B4A0" }
                      : { color: "#4C47A2" }
                  }
                >
                  {parseFloat(row.original.Profit) > 0 ? "+ " : "- "}
                  {account?.AccountCurrency == "EUR" ? "€" : "$"}
                  {parseFloat(row.original.Profit) > 0
                    ? parseFloat(
                        row.original.Profit *
                          (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                      ).toFixed(1)
                    : parseFloat(
                        row.original.Profit *
                          (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                      )
                        .toFixed(1)
                        .slice(1)}
                </div>
              )}
            </span>
          );
        },
      },
      {
        accessorKey: "Actions",
        header: "",
        grow: 1,
        size: 40,
        enableSorting: false,

        Cell: ({ row }) => {
          return (
            <button
              onClick={() => {
                Close(row.original);
              }}
              style={
                row.original.Status === "BUY"
                  ? parseFloat(row.original.Profit) > 0
                    ? {
                        cursor: "pointer",
                        background: "#00B4A0",
                        fontSize: "1.6vh",
                        color: "#FCFCFC",
                        padding: "0.8vh 1.2vh",
                        border: "none",
                        borderRadius: "1004px",
                        fontFamily: "'Inter',sans-serif",
                      }
                    : {
                        cursor: "pointer",
                        background: "#4C47A2",
                        fontSize: "1.6vh",
                        color: "#FCFCFC",
                        padding: "0.8vh 1.2vh",
                        border: "none",
                        borderRadius: "1004px",
                        fontFamily: "'Inter',sans-serif",
                      }
                  : parseFloat(row.original.Profit) * -1 > 0
                  ? {
                      cursor: "pointer",
                      background: "#4C47A2",
                      fontSize: "1.6vh",
                      color: "#FCFCFC",
                      padding: "0.8vh 1.2vh",
                      border: "none",
                      borderRadius: "1004px",
                      fontFamily: "'Inter',sans-serif",
                    }
                  : {
                      cursor: "pointer",
                      background: "#00B4A0",
                      fontSize: "1.6vh",
                      color: "#FCFCFC",
                      padding: "0.8vh 1.2vh",
                      border: "none",
                      borderRadius: "1004px",
                      fontFamily: "'Inter',sans-serif",
                    }
              }
            >
              Close
            </button>
          );
        },
      },
    ],
    [i18n.language, AssetsList]
  );

  const columnsDeferred = useMemo(
    () => [
      {
        accessorKey: "Id",
        header: t("OrderId"),
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("OrderId")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        grow: 1,
        size: 40,
      },
      {
        accessorKey: "TimeInForceDate",
        header: t("Open Date"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Open Date")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span>
              {moment(row.original.TimeInForceDate).format("YYYY-MM-DD")}
              <span style={{ color: theme === "dark" ? "#51525C" : "#9CA3AF" }}>
                {" "}
                {moment(row.original.TimeInForceDate).format("HH:mm")}
              </span>
            </span>
          );
        },
      },
      {
        accessorKey: "Title",
        header: t("Instrument"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Instrument")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span style={{ cursor: "pointer" }}>
              {account?.AccountCurrency == "EUR"
                ? row.original.Subtitle.slice(1, -1).replace("/USD", "/EUR")
                : row.original.Subtitle.slice(1, -1)}
            </span>
          );
        },
      },
      {
        accessorKey: "Status",
        header: t("Type"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Type")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span
              style={
                row.original.Status === "BUYD"
                  ? {
                      color: "#00B4A0",
                      backgroundColor: "rgba(0, 180, 160, 0.08)",
                      padding: "0.4vh 1.2vh",
                      borderRadius: "100px",
                    }
                  : row.original.Status === "SELLD"
                  ? {
                      color: "#4C47A2",
                      backgroundColor: "rgba(246, 61, 104, 0.08)",
                      padding: "0.4vh 1.2vh",
                      borderRadius: "100px",
                    }
                  : {
                      backgroundColor: "rgba(233, 119, 14, 0.08)",
                      color: "#E9770E",
                      padding: "0.4vh 1.2vh",
                      borderRadius: "100px",
                    }
              }
            >
              {row.original.Status.slice(0, 1) +
                row.original.Status.slice(1, -1).toLowerCase()}
            </span>
          );
        },
      },
      {
        accessorKey: "Price",
        header: t("Margin"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Margin")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span>
              {account?.AccountCurrency == "EUR" ? "€" : "$"}
              {parseFloat(
                (row.original.OpenWhen *
                  (account?.AccountCurrency == "EUR" ? eurToUsd : 1) *
                  row.original.Count *
                  row.original.LotSize) /
                  row.original.Leverage
              ).toFixed(5)}
            </span>
          );
        },
      },
      {
        accessorKey: "StartPrice",
        header: t("EntryPrice"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("EntryPrice")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span>
              {account?.AccountCurrency == "EUR" ? "€" : "$"}
              {(
                row.original.OpenWhen *
                (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
              )?.toFixed(5)}
            </span>
          );
        },
      },
      // {
      //     accessorKey: 'Liquidation',
      //     header: t('Liquidation'),
      //     size: 110,
      //     Header: () => (
      //         <div className={styles.header_cell}>
      //             <span style={{ fontWeight: '500', lineHeight: '1.6vh' }} className={styles.header_name}>{t('Liquidation')}</span>
      //             <div className={styles.sort_icon}>
      //                 <svg xmlns="http://www.w3.org/2000/svg" width={"0.8vh"} height={"0.5vh"} viewBox="0 0 8 5" fill="none">
      //                     <path d="M1 4L4 1L7 4" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      //                 </svg>
      //                 <svg xmlns="http://www.w3.org/2000/svg" width={"0.8vh"} height={"0.5vh"} viewBox="0 0 8 5" fill="none">
      //                     <path d="M7 1L4 4L1 1" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      //                 </svg>
      //             </div>
      //         </div>
      //     ),
      //     Cell: ({ row }) => {
      //         return (
      //             <span style={row.original.Leverage !== 1 ? { color: '#4C47A2' } : { color: '#9F9C9C' }}>
      //                 {getLiquidationPrice(row)}
      //             </span>
      //         )
      //     },
      // },
      {
        accessorKey: "Leverage",
        header: t("Leverage"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Leverage")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span
              style={{
                backgroundColor: "rgba(233, 119, 14, 0.08)",
                color: "#E9770E",
                padding: "0.4vh 1.2vh",
                borderRadius: "100px",
              }}
            >
              X{row.original.Leverage}
            </span>
          );
        },
      },
      // {
      //     accessorKey: 'Profit',
      //     header: t('Profit'),
      //     size: 80,
      //     Header: () => (
      //         <div className={styles.header_cell}>
      //             <span style={{ fontWeight: '500', lineHeight: '1.6vh' }} className={styles.header_name}>{t('Profit')}</span>
      //             <div className={styles.sort_icon}>
      //                 <svg xmlns="http://www.w3.org/2000/svg" width={"0.8vh"} height={"0.5vh"} viewBox="0 0 8 5" fill="none">
      //                     <path d="M1 4L4 1L7 4" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      //                 </svg>
      //                 <svg xmlns="http://www.w3.org/2000/svg" width={"0.8vh"} height={"0.5vh"} viewBox="0 0 8 5" fill="none">
      //                     <path d="M7 1L4 4L1 1" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      //                 </svg>
      //             </div>
      //         </div>
      //     ),
      //     Cell: ({ row }) => {
      //         return (
      //             <span>
      //                 {
      //                     row.original.Status === 'BUY' ?
      //                         <div style={parseFloat(row.original.Profit) > 0 ? { color: '#00B4A0' } : { color: '#4C47A2' }}>
      //                             {parseFloat(row.original.Profit) > 0 ? '+ ' : '- '}
      //                             {
      //                                 account?.AccountCurrency == "EUR"
      //                                     ?
      //                                     "€"
      //                                     :
      //                                     "$"
      //                             }
      //                             {parseFloat((row.original.Profit * (account?.AccountCurrency == "EUR" ? eurToUsd : 1))).toFixed(2)}
      //                         </div>
      //                         :
      //                         <div style={parseFloat(row.original.Profit) > 0 ? { color: '#00B4A0' } : { color: '#4C47A2' }}>
      //                             {parseFloat(row.original.Profit) > 0 ? '+ ' : '- '}
      //                             {
      //                                 account?.AccountCurrency == "EUR"
      //                                     ?
      //                                     "€"
      //                                     :
      //                                     "$"
      //                             }
      //                             {parseFloat((row.original.Profit * (account?.AccountCurrency == "EUR" ? eurToUsd : 1))).toFixed(2).slice(1)}
      //                         </div>
      //                 }
      //             </span>
      //         )
      //     },
      // },
      {
        accessorKey: "Take",
        header: t("Take-Profit"),
        grow: 1,
        size: 40,
        enableSorting: false,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Take-Profit")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={toggleEditDrawer(true, row.original)}
            >
              <span style={{ fontSize: "1.2vh", color: "#3F3F46" }}>
                {row.original.TakeProfit ? (
                  <span style={{ color: "#00B4A0" }}>
                    {row.original.TakeProfit
                              ? parseFloat(row.original.TakeProfit) > 1
                                ? (row.original.TakeProfit *
                                  (account?.AccountCurrency == "EUR" ? eurToUsd : 1))?.toFixed(2)
                                : (row.original.TakeProfit *
                                  (account?.AccountCurrency == "EUR" ? eurToUsd : 1))?.toFixed(5)
                              : " 0"} {account?.AccountCurrency == "EUR" ? "€" : "$"}
                  </span>
                ) : (
                  <span style={{ color: "#00B4A0" }}>
                    0 {account?.AccountCurrency == "EUR" ? "€" : "$"}
                  </span>
                )}
              </span>
            </span>
          );
        },
      },
      {
        accessorKey: "Stop",
        header: t("Stop-Loss"),
        grow: 1,
        size: 40,
        enableSorting: false,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Stop-Loss")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={toggleEditDrawer(true, row.original)}
            >
              <span style={{ fontSize: "1.2vh", color: "#3F3F46" }}>
                {row.original.StopLoss ? (
                  <span style={{ color: "#4C47A2" }}>
                    {row.original.StopLoss
                    ? parseFloat(row.original.StopLoss) > 1
                      ? (row.original.StopLoss *
                        (account?.AccountCurrency == "EUR" ? eurToUsd : 1))?.toFixed(2)
                      : (row.original.StopLoss *
                        (account?.AccountCurrency == "EUR" ? eurToUsd : 1))?.toFixed(5)
                    : " 0"} {account?.AccountCurrency == "EUR" ? "€" : "$"}
                  </span>
                ) : (
                  <span style={{ color: "#4C47A2" }}>
                    0 {account?.AccountCurrency == "EUR" ? "€" : "$"}
                  </span>
                )}
              </span>
            </span>
          );
        },
      },
      {
        accessorKey: "Actions",
        header: "",
        grow: 1,
        size: 40,
        grow: 1,
        enableSorting: false,

        Cell: ({ row }) => {
          return (
            <button
              onClick={() => {
                Sell(row.original);
              }}
              style={
                row.original.Status === "BUY"
                  ? parseFloat(row.original.Profit) > 0
                    ? {
                        cursor: "pointer",
                        background: "#00B4A0",
                        fontSize: "1.6vh",
                        color: "#FCFCFC",
                        padding: "0.8vh 1.2vh",
                        border: "none",
                        borderRadius: "1004px",
                        fontFamily: "'Inter',sans-serif",
                      }
                    : {
                        cursor: "pointer",
                        background: "#4C47A2",
                        fontSize: "1.6vh",
                        color: "#FCFCFC",
                        padding: "0.8vh 1.2vh",
                        border: "none",
                        borderRadius: "1004px",
                        fontFamily: "'Inter',sans-serif",
                      }
                  : parseFloat(row.original.Profit) * -1 > 0
                  ? {
                      cursor: "pointer",
                      background: "#4C47A2",
                      fontSize: "1.6vh",
                      color: "#FCFCFC",
                      padding: "0.8vh 1.2vh",
                      border: "none",
                      borderRadius: "1004px",
                      fontFamily: "'Inter',sans-serif",
                    }
                  : {
                      cursor: "pointer",
                      background: "#00B4A0",
                      fontSize: "1.6vh",
                      color: "#FCFCFC",
                      padding: "0.8vh 1.2vh",
                      border: "none",
                      borderRadius: "1004px",
                      fontFamily: "'Inter',sans-serif",
                    }
              }
            >
              Close
            </button>
          );
        },
      },
    ],
    [i18n.language, AssetsList]
  );
  const columnsClosed = useMemo(
    () => [
      {
        accessorKey: "Id",
        header: t("OrderId"),
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("OrderId")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        grow: 1,
        size: 40,
      },
      {
        accessorKey: "TimeInForceDate",
        header: t("Open Date"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Open Date")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span>
              {moment(row.original.TimeInForceDate).format("YYYY-MM-DD")}
              <span style={{ color: theme === "dark" ? "#51525C" : "#9CA3AF" }}>
                {" "}
                {moment(row.original.TimeInForceDate).format("HH:mm")}
              </span>
            </span>
          );
        },
      },
      {
        accessorKey: "Date",
        header: t("Date"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Date")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ renderedCellValue, row }) => {
          return (
            <span>
              {moment(row.original.Date).format("YYYY-MM-DD")}
              <span style={{ color: theme === "dark" ? "#51525C" : "#9CA3AF" }}>
                {" "}
                {moment(row.original.Date).format("HH:mm")}
              </span>
            </span>
          );
        },
      },
      {
        accessorKey: "Title",
        header: t("Instrument"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Instrument")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ renderedCellValue, row }) => {
          return (
            <span style={{ cursor: "pointer" }}>
              {account?.AccountCurrency == "EUR"
                ? row.original.SubTitle.slice(1, -1).replace("/USD", "/EUR")
                : row.original.SubTitle.slice(1, -1)}
            </span>
          );
        },
      },
      {
        accessorKey: "OrderType",
        header: t("Type"),
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Type")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        grow: 1,
        size: 40,
        Cell: ({ renderedCellValue, row }) => {
          return (
            <span
              style={
                row.original.OrderType?.includes("BUY")
                  ? {
                      color: "#00B4A0",
                      backgroundColor: "rgba(0, 180, 160, 0.08)",
                      padding: "0.4vh 1.2vh",
                      borderRadius: "100px",
                    }
                  : row.original.OrderType?.includes("SELL")
                  ? {
                      color: "#4C47A2",
                      backgroundColor: "rgba(246, 61, 104, 0.08)",
                      padding: "0.4vh 1.2vh",
                      borderRadius: "100px",
                    }
                  : {}
              }
            >
              {row.original.OrderType?.includes("D")
                ? row.original.OrderType?.slice(0, -1)
                : row.original?.OrderType?.slice(0, 1) +
                  row.original.OrderType?.slice(1).toLowerCase()}
            </span>
          );
        },
      },
      {
        accessorKey: "Leverage",
        header: t("Leverage"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Leverage")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ renderedCellValue, row }) => {
          return (
            <span
              style={{
                backgroundColor: "rgba(233, 119, 14, 0.08)",
                color: "#E9770E",
                padding: "0.4vh 1.2vh",
                borderRadius: "100px",
              }}
            >
              X{row.original.Leverage}
            </span>
          );
        },
      },
      // {
      //     accessorKey: 'Price',
      //     header: t('Amount'),
      //     Header: () => (
      //         <div className={styles.header_cell}>
      //             <span style={{ fontWeight: '500', lineHeight: '1.6vh' }} className={styles.header_name}>{t('Amount')}</span>
      //             <div className={styles.sort_icon}>
      //                 <svg xmlns="http://www.w3.org/2000/svg" width={"0.8vh"} height={"0.5vh"} viewBox="0 0 8 5" fill="none">
      //                     <path d="M1 4L4 1L7 4" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      //                 </svg>
      //                 <svg xmlns="http://www.w3.org/2000/svg" width={"0.8vh"} height={"0.5vh"} viewBox="0 0 8 5" fill="none">
      //                     <path d="M7 1L4 4L1 1" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      //                 </svg>
      //             </div>
      //         </div>
      //     ),
      //     grow: 1,
      //     size: 40,
      //     Cell: ({ renderedCellValue, row }) => {
      //         return (
      //             <span>
      //                 {
      //                     account?.AccountCurrency == "EUR"
      //                         ?
      //                         "€"
      //                         :
      //                         "$"
      //                 }
      //                 {(row.original.Price * (account?.AccountCurrency == "EUR" ? eurToUsd : 1))?.toFixed(5)}
      //             </span>
      //         )
      //     },
      // },
      {
        accessorKey: "StartPrice",
        header: t("EntryPrice"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("EntryPrice")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ renderedCellValue, row }) => {
          return (
            <span>
              {account?.AccountCurrency == "EUR" ? "€" : "$"}
              {(
                row.original.StartPrice *
                (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
              )?.toFixed(5)}
            </span>
          );
        },
      },
      {
        accessorKey: "EndPrice",
        header: t("EndPrice"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("EndPrice")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ renderedCellValue, row }) => {
          return (
            <span>
              {account?.AccountCurrency == "EUR" ? "€" : "$"}
              {(
                row.original.EndPrice *
                (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
              )?.toFixed(5)}
            </span>
          );
        },
      },
      {
        accessorKey: "Take",
        header: t("Take-Profit"),
        grow: 1,
        size: 40,
        enableSorting: false,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Take-Profit")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={toggleEditDrawer(true, row.original)}
            >
              <span style={{ fontSize: "1.2vh", color: "#3F3F46" }}>
                {row.original.TakeProfit ? (
                  <span style={{ color: "#00B4A0" }}>
                    {(
                      row.original.TakeProfit *
                      (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                    ).toFixed(4)}
                    {account?.AccountCurrency == "EUR" ? "€" : "$"}
                  </span>
                ) : (
                  <span style={{ color: "#00B4A0" }}>
                    0 {account?.AccountCurrency == "EUR" ? "€" : "$"}
                  </span>
                )}
              </span>
            </span>
          );
        },
      },
      {
        accessorKey: "Stop",
        header: t("Stop-Loss"),
        grow: 1,
        size: 40,
        enableSorting: false,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Stop-Loss")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={toggleEditDrawer(true, row.original)}
            >
              <span style={{ fontSize: "1.2vh", color: "#3F3F46" }}>
                {row.original.StopLoss ? (
                  <span style={{ color: "#4C47A2" }}>
                    {(
                      row.original.StopLoss *
                      (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                    ).toFixed(4)}
                    {account?.AccountCurrency == "EUR" ? "€" : "$"}
                  </span>
                ) : (
                  <span style={{ color: "#4C47A2" }}>
                    0 {account?.AccountCurrency == "EUR" ? "€" : "$"}
                  </span>
                )}
              </span>
            </span>
          );
        },
      },
      {
        accessorKey: "Profit",
        header: t("Profit"),
        grow: 1,
        size: 40,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Profit")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ renderedCellValue, row }) => {
          return (
            <span
              style={
                row.original?.Profit < 0
                  ? { color: "#4C47A2", fontWeight: "500" }
                  : { color: "#00B4A0", fontWeight: "500" }
              }
            >
              {row.original.Status === "CLOSED" ? (
                `${(
                  row.original?.Profit *
                  (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                ).toFixed(5)} ${account?.AccountCurrency == "EUR" ? "€" : "$"}`
              ) : (
                <span style={{ color: "#4C47A2" }}>
                  {"-" +
                    (
                      row.original?.Price *
                      (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                    ).toFixed(5)}{" "}
                  {account?.AccountCurrency == "EUR" ? "€" : "$"}
                </span>
              )}
            </span>
          );
        },
      },
    ],
    [i18n.language, AssetsList]
  );
  const [openDrawer, setOpenDrawer] = useState(false);
  const [ordersOpened, setOrdersOpened] = useState(true);
  const [openDrawerAssets, setOpenDrawerAssets] = useState(false);
  const [openOrderDrawer, setOpenOrderDrawer] = useState(false);
  const [activeOrder, setActiveOrder] = useState({});

  const toggleDrawerAssets = (newOpen, type) => () => {
    setOpenDrawerAssets(newOpen);
  };
  const toggleDrawer = (newOpen, type) => () => {
    setOpenDrawer(newOpen);
    handleTabOrderChange(type);
  };
  const toggleOrderDrawer = (newOpen, element) => () => {
    setOpenOrderDrawer(newOpen);
    setActiveOrder(element);
  };
  const updateBackgroundPositionOrder = () => {
    let targetTab;
    switch (selectedOrderTab) {
      case "buy":
        targetTab = buyOrder.current;
        break;
      case "sell":
        targetTab = sellOrder.current;
        break;
      default:
        targetTab = buyOrder.current;
    }

    if (targetTab) {
      setBackgroundOrderStyle({
        width: targetTab.offsetWidth,
        height: targetTab.offsetHeight,
        transform: `translateX(${targetTab.offsetLeft - 3}px)`,
        transition: "background-color 0.3s ease, transform 0.3s ease",
      });
    }
  };
  useEffect(() => {
    if (openDrawer) updateBackgroundPositionOrder();
  }, [openDrawer]);
  useEffect(() => {
    if (selectedOrderTab) updateBackgroundPositionOrder();
  }, [selectedOrderTab]);

  const [currentRecordsT, setCurrentRecordsT] = useState([]);
  const [currentRecordsTD, setCurrentRecordsTD] = useState([]);
  const [historyT, setHistoryT] = useState([]);

  useEffect(() => {
    console.log(historyT);
    console.log(currentRecordsT);
    console.log(currentRecordsTD);
  }, [historyT, currentRecordsT, currentRecordsTD]);

  useEffect(() => {
    setCurrentRecordsT(
      currentRecords?.filter((val) => !val.Status?.includes("D"))
    );
    setCurrentRecordsTD(
      currentRecords?.filter((val) => val.Status?.includes("D"))
    );
    setHistoryT(history);
  }, [AssetsList, currentRecords, history]);

  useEffect(() => {
    if (currentRecordsT.length > 0) {
      let temp = currentRecordsT.reduce(
        (sum, currentValue) =>
          sum +
          (currentValue.Status === "BUY"
            ? +parseFloat(currentValue?.Profit)?.toFixed(1)
            : +parseFloat(currentValue?.Profit)?.toFixed(1)),
        0
      );
      setProfit(temp);
    }
  }, [currentRecordsT]);
  return (
    <div className={styles.main}>
      <div className={styles.main_block}>
        <div className={styles.block_title}>
          <div className={styles.leftside}>
            {/* <button
                className={styles.marketButton}
                onClick={toggleDrawerAssets(true)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M14.6667 3.33334C14.6667 4.43791 13.7712 5.33334 12.6667 5.33334C11.5621 5.33334 10.6667 4.43791 10.6667 3.33334C10.6667 2.22877 11.5621 1.33334 12.6667 1.33334C13.7712 1.33334 14.6667 2.22877 14.6667 3.33334Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 1.33334C8.93251 1.33334 9.72667 1.33334 10.408 1.35885C9.94638 1.88646 9.66666 2.57723 9.66666 3.33334C9.66666 4.9902 11.0098 6.33334 12.6667 6.33334C13.4228 6.33334 14.1135 6.05362 14.6412 5.59202C14.6667 6.27334 14.6667 7.0675 14.6667 8.00001C14.6667 11.1427 14.6667 12.7141 13.6904 13.6904C12.714 14.6667 11.1427 14.6667 8 14.6667C4.8573 14.6667 3.28595 14.6667 2.30964 13.6904C1.33333 12.7141 1.33333 11.1427 1.33333 8.00001C1.33333 4.85731 1.33333 3.28596 2.30964 2.30965C3.28595 1.33334 4.8573 1.33334 8 1.33334ZM9.66666 7.16668C9.39052 7.16668 9.16666 6.94282 9.16666 6.66668C9.16666 6.39053 9.39052 6.16668 9.66666 6.16668H11.3333C11.6095 6.16668 11.8333 6.39053 11.8333 6.66668V8.33334C11.8333 8.60949 11.6095 8.83334 11.3333 8.83334C11.0572 8.83334 10.8333 8.60949 10.8333 8.33334V7.87378L9.49162 9.21549C9.03601 9.6711 8.29732 9.6711 7.8417 9.21549L6.78451 8.1583C6.71943 8.09321 6.6139 8.09321 6.54881 8.1583L5.02022 9.6869C4.82495 9.88216 4.50837 9.88216 4.31311 9.6869C4.11785 9.49163 4.11785 9.17505 4.31311 8.97979L5.8417 7.45119C6.29732 6.99558 7.03601 6.99558 7.49162 7.45119L8.54881 8.50839C8.6139 8.57347 8.71943 8.57347 8.78451 8.50839L10.1262 7.16668H9.66666Z"
                    fill="white"
                  />
                </svg>
                <span>{t("Market")}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M1.33334 7.33333C1.33334 4.81918 1.33334 3.5621 2.11439 2.78105C2.89544 2 4.15252 2 6.66668 2H9.33334C11.8475 2 13.1046 2 13.8856 2.78105C14.6667 3.5621 14.6667 4.81918 14.6667 7.33333V8.66667C14.6667 11.1808 14.6667 12.4379 13.8856 13.219C13.1046 14 11.8475 14 9.33334 14H6.66668C4.15252 14 2.89544 14 2.11439 13.219C1.33334 12.4379 1.33334 11.1808 1.33334 8.66667V7.33333Z"
                    stroke="white"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M10 14L10 2"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </button> */}
            <div className={styles.active_name}>
            {assetsLogo[activeAsset?.Ticker] ? (
  <div
    dangerouslySetInnerHTML={{ __html: assetsLogo[activeAsset?.Ticker] }}
    style={{ width: '32px', height: '32px', overflow: 'hidden' }}
  />
) : (
  <img
    src={`https://cdn.jsdelivr.net/gh/vadimmalykhin/binance-icons/crypto/${activeAsset?.Subtitle.slice(
      1,
      4
    ).toLowerCase()}.svg`}
    alt="icon"
    onError={handleImgError}
    style={{ width: '32px', height: '32px', borderRadius: '50%' }}
  />
)}
              <div className={styles.name}>
                <span className={styles.subtitle}>
                  {account?.AccountCurrency == "EUR"
                    ? activeAsset?.Subtitle.slice(1, -1).replace("/USD", "/EUR")
                    : activeAsset?.Subtitle.slice(1, -1)}
                </span>
                <span className={styles.title}>{activeAsset?.Title}</span>
              </div>
            </div>
            <div className={styles.active_values}>
              <div className={styles.price}>
                {parseFloat(
                  secureLocalStorage.getItem("selected_account")
                    ?.AccountCurrency === "EUR"
                    ? activePrice * eurToUsd
                    : activePrice
                ).toFixed(5)}
                <span>{t("Price")}</span>
              </div>
              <div
                style={{
                  color: !activeAsset?.Tendency.includes("-")
                    ? "#35B0BA"
                    : "#4C47A2",
                }}
                className={styles.day_changes}
              >
                {activeAsset?.Tendency}
                <span>{t("Change 24h")}</span>
              </div>
              <div className={styles.day_high}>
                {parseFloat(
                  secureLocalStorage.getItem("selected_account")
                    ?.AccountCurrency === "EUR"
                    ? activePrice * eurToUsd
                    : activePrice
                ).toFixed(5)}
                <span>{t("24h high")}</span>
              </div>
              <div className={styles.day_low}>
                {parseFloat(
                  secureLocalStorage.getItem("selected_account")
                    ?.AccountCurrency === "EUR"
                    ? activeAsset?.Low * eurToUsd
                    : activeAsset?.Low
                ).toFixed(5)}
                <span>{t("24h low")}</span>
              </div>
            </div>
          </div>
          <div className={styles.rightside}>
            <div className={styles.favorites}>
              {favorites?.includes(activeAsset?.Id) ? (
                <svg
                  onClick={() => toggleFavorite(activeAsset?.Id)}
                  xmlns="http://www.w3.org/2000/svg"
                  width={"2vh"}
                  height={"2vh"}
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M7.62796 4.50682C8.6835 2.61328 9.21127 1.6665 10.0003 1.6665C10.7894 1.6665 11.3171 2.61327 12.3727 4.50682L12.6458 4.9967C12.9457 5.53478 13.0957 5.80383 13.3295 5.98134C13.5634 6.15886 13.8546 6.22475 14.4371 6.35654L14.9674 6.47653C17.0171 6.9403 18.042 7.17219 18.2858 7.95628C18.5296 8.74037 17.831 9.5574 16.4336 11.1914L16.0721 11.6142C15.675 12.0785 15.4764 12.3107 15.3871 12.5979C15.2978 12.8852 15.3278 13.1949 15.3878 13.8145L15.4425 14.3785C15.6538 16.5587 15.7594 17.6488 15.121 18.1334C14.4827 18.6179 13.5231 18.1761 11.6039 17.2925L11.1074 17.0639C10.5621 16.8128 10.2894 16.6872 10.0003 16.6872C9.71128 16.6872 9.4386 16.8128 8.89323 17.0639L8.39672 17.2925C6.47755 18.1761 5.51797 18.6179 4.87962 18.1334C4.24126 17.6488 4.34689 16.5587 4.55816 14.3785L4.61281 13.8145C4.67285 13.1949 4.70286 12.8852 4.61354 12.5979C4.52423 12.3107 4.32568 12.0785 3.92859 11.6142L3.56707 11.1914C2.1697 9.5574 1.47101 8.74037 1.71484 7.95628C1.95867 7.17219 2.98354 6.9403 5.03327 6.47653L5.56356 6.35654C6.14603 6.22476 6.43727 6.15886 6.67111 5.98134C6.90495 5.80383 7.05493 5.53478 7.35488 4.9967L7.62796 4.50682Z"
                    fill="#E9B90E"
                  />
                </svg>
              ) : (
                <svg
                  onClick={() => toggleFavorite(activeAsset?.Id)}
                  xmlns="http://www.w3.org/2000/svg"
                  width={"2vh"}
                  height={"2vh"}
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M7.62796 4.50682C8.6835 2.61328 9.21127 1.6665 10.0003 1.6665C10.7894 1.6665 11.3171 2.61327 12.3727 4.50682L12.6458 4.9967C12.9457 5.53478 13.0957 5.80383 13.3295 5.98134C13.5634 6.15886 13.8546 6.22475 14.4371 6.35654L14.9674 6.47653C17.0171 6.9403 18.042 7.17219 18.2858 7.95628C18.5296 8.74037 17.831 9.5574 16.4336 11.1914L16.0721 11.6142C15.675 12.0785 15.4764 12.3107 15.3871 12.5979C15.2978 12.8852 15.3278 13.1949 15.3878 13.8145L15.4425 14.3785C15.6538 16.5587 15.7594 17.6488 15.121 18.1334C14.4827 18.6179 13.5231 18.1761 11.6039 17.2925L11.1074 17.0639C10.5621 16.8128 10.2894 16.6872 10.0003 16.6872C9.71128 16.6872 9.4386 16.8128 8.89323 17.0639L8.39672 17.2925C6.47755 18.1761 5.51797 18.6179 4.87962 18.1334C4.24126 17.6488 4.34689 16.5587 4.55816 14.3785L4.61281 13.8145C4.67285 13.1949 4.70286 12.8852 4.61354 12.5979C4.52423 12.3107 4.32568 12.0785 3.92859 11.6142L3.56707 11.1914C2.1697 9.5574 1.47101 8.74037 1.71484 7.95628C1.95867 7.17219 2.98354 6.9403 5.03327 6.47653L5.56356 6.35654C6.14603 6.22476 6.43727 6.15886 6.67111 5.98134C6.90495 5.80383 7.05493 5.53478 7.35488 4.9967L7.62796 4.50682Z"
                    stroke={theme === "dark" ? "#FCFCFC" : "#1F2937"}
                  />
                </svg>
              )}
            </div>
          </div>
          <div className={styles.trading_orders}>
            <div className={styles.background} style={backgroundTradingStyle} />
            <button
              ref={trading}
              className={`${styles.tab} ${
                selectedTradingTab === "trading" ? styles.active : ""
              }`}
              onClick={() => {
                handleTabTradingChange("trading");
              }}
            >
              {t("Trading")}
            </button>
            <button
              ref={orders}
              className={`${styles.tab} ${
                selectedTradingTab === "orders" ? styles.active : ""
              }`}
              onClick={() => {
                handleTabTradingChange("orders");
              }}
            >
              {t("Orders")}
            </button>
          </div>
          {selectedTradingTab === "trading" && (
            <>
              <div
                className={styles.mobile_assets}
                onClick={toggleAssetsDrawer(true)}
              >
                <div className={styles.left}>
                {assetsLogo[activeAsset?.Ticker] ? (
  <div
    dangerouslySetInnerHTML={{ __html: assetsLogo[activeAsset?.Ticker] }}
    style={{ width: '32px', height: '32px', borderRadius: '50%', overflow: 'hidden' }}
  />
) : (
  <img
    src={`https://cdn.jsdelivr.net/gh/vadimmalykhin/binance-icons/crypto/${activeAsset?.Subtitle.slice(
      1,
      4
    ).toLowerCase()}.svg`}
    alt="icon"
    onError={handleImgError}
    style={{ width: '32px', height: '32px', borderRadius: '50%' }}
  />
)}

                  <div className={styles.title_price}>
                    <span className={styles.title}>
                      {activeAsset?.Subtitle
                        ? account?.AccountCurrency == "EUR"
                          ? activeAsset?.Subtitle?.slice(1, -1).replace(
                              "/USD",
                              "/EUR"
                            )
                          : activeAsset?.Subtitle?.slice(1, -1)
                        : account?.AccountCurrency == "EUR"
                        ? activeAsset?.SubTitle?.slice(1, -1).replace(
                            "/USD",
                            "/EUR"
                          )
                        : activeAsset?.SubTitle?.slice(1, -1)}
                    </span>
                    <span className={styles.price}>
                      {activePrice?.toFixed(activePrice > 1 ? 2 : 4)}
                    </span>
                  </div>
                </div>
                <div className={styles.icon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M12.6666 6L7.99992 10L3.33325 6"
                      stroke="#FCFCFC"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>

              <div
                className={styles.buy_sell}
                style={{
                  display: window.innerWidth < 1501 ? "flex" : "none",
                }}
              >
                <button onClick={toggleDrawer(true, "sell")}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                  >
                    <path
                      d="M13.1667 7.33337L8.50004 11.3334L3.83337 7.33337"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M13.1667 4.66663L8.50004 8.66663L3.83337 4.66663"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span>{t("Sell")}</span>
                </button>
                <button onClick={toggleDrawer(true, "buy")}>
                  <span>{t("Buy")}</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M12.6667 8.66663L8.00004 4.66663L3.33337 8.66663"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12.6667 11.3334L8.00004 7.33337L3.33337 11.3334"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </>
          )}
        </div>
        {selectedTradingTab === "orders" ? (
          <div className={styles.mobile_orders}>
            <div className={styles.search} onClick={handleSearchClick}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"1.6vh"}
                height={"1.6vh"}
                viewBox="0 0 16 16"
                fill="none"
              >
                <g clipPath="url(#clip0_436_4317)">
                  <circle
                    cx="7.66634"
                    cy="7.66683"
                    r="6.33333"
                    stroke="#51525C"
                  />
                  <path
                    d="M13.333 13.3335L14.6663 14.6668"
                    stroke="#51525C"
                    strokeLinecap="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_436_4317">
                    <rect width={16} height={16} fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <input ref={inputRef} placeholder={t("Search")} />
            </div>
            <div className={styles.mobile_orders_tabs}>
              <div
                className={styles.background}
                style={backgroundMobileStyle}
              />
              <button
                ref={openMobile}
                className={`${styles.tab} ${
                  selectedMobileTab === "open" ? styles.active : ""
                }`}
                onClick={() => handleTabMobileChange("open")}
              >
                {t("Open Orders")}
              </button>
              <button
                ref={deferredMobile}
                className={`${styles.tab} ${
                  selectedMobileTab === "deferred" ? styles.active : ""
                }`}
                onClick={() => handleTabMobileChange("deferred")}
              >
                {t("Deferred Orders")}
              </button>
              <button
                ref={closeMobile}
                className={`${styles.tab} ${
                  selectedMobileTab === "close" ? styles.active : ""
                }`}
                onClick={() => handleTabMobileChange("close")}
              >
                {t("History")}
              </button>
            </div>
            {selectedMobileTab === "close" && (
              <div className={styles.transactions_list}>
                {historyT.map((el) => (
                  <div
                    onClick={toggleOrderDrawer(true, el)}
                    className={styles.transaction}
                    key={el.Id}
                  >
                    <div className={styles.type_status}>
                      <div className={`${styles.left_side}`}>
                      {assetsLogo[AssetsList?.find(val=>val.Title === el.Asset)?.Ticker] ? (
  <div
    dangerouslySetInnerHTML={{ __html: assetsLogo[AssetsList?.find(val=>val.Title === el.Asset)?.Ticker] }}
    style={{
      width: '32px',
      height: '32px',
      overflow: 'hidden',
    }}
  />
) : (
  <img
    src={`https://cdn.jsdelivr.net/gh/vadimmalykhin/binance-icons/crypto/${el.SubTitle.slice(
      1,
      4
    ).toLowerCase()}.svg`}
    alt="icon"
    onError={handleImgError}
    style={{
      width: '32px',
      height: '32px',
      borderRadius: '50%',
    }}
  />
)}

                        {account?.AccountCurrency == "EUR"
                          ? el.SubTitle.slice(1, -1).replace("/USD", "/EUR")
                          : el.SubTitle.slice(1, -1)}
                        <span
                          className={`${styles.type} ${
                            el.OrderType?.includes("BUY")
                              ? styles.buy
                              : el.OrderType?.includes("SELL")
                              ? styles.sell
                              : styles.simulate
                          }`}
                        >
                          {el.OrderType}
                        </span>
                        <span className={styles.leverage}>x{el.Leverage}</span>
                      </div>
                      <div className={styles.right_side}>
                        <span className={`${styles.type} ${styles.simulate}`}>
                          {el.Status?.slice(0, 1) +
                            el.Status?.slice(1).toLowerCase()}
                        </span>
                      </div>
                    </div>
                    <hr />
                    <div className={styles.account_amount}>
                      <div className={styles.account}>
                        <label htmlFor="">{t("Profit")}</label>
                        <p
                          style={{
                            color:
                              parseFloat(el.Profit) > 0 ? "#35B0BA" : "#4C47A2",
                          }}
                        >
                          {el.Profit > 0 ? "+" : ""}
                          {parseFloat(`${el.Profit}`.slice(1)) > 1
                            ? " " +
                              (el.Profit < 0
                                ? "- " +
                                  parseFloat(`${el.Profit}`.slice(1)).toFixed(2)
                                : el.Profit?.toFixed(2))
                            : " " +
                              (el.Profit < 0
                                ? "- " +
                                  parseFloat(`${el.Profit}`.slice(1)).toFixed(5)
                                : el.Profit?.toFixed(5))}
                          {account?.AccountCurrency == "EUR" ? " €" : " $"}
                        </p>
                      </div>
                      <div
                        className={styles.account}
                        style={{ alignItems: "end" }}
                      >
                        <label htmlFor="">{t("Date")}</label>
                        <p>{moment(el.Date).format("YYYY-MM-DD HH:mm")}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {selectedMobileTab === "deferred" && (
              <div className={styles.transactions_list}>
                {currentRecordsTD?.map((el) => (
                  <div className={styles.transaction} key={el.Id}>
                    <div
                      className={styles.type_status}
                      onClick={toggleOrderDrawer(true, el)}
                    >
                      <div className={`${styles.left_side}`}>
                      {assetsLogo[AssetsList?.find(val=>val.Title === el.Title)?.Ticker] ? (
  <div
    dangerouslySetInnerHTML={{ __html: assetsLogo[AssetsList?.find(val=>val.Title === el.Title)?.Ticker] }}
    style={{
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      overflow: 'hidden',
    }}
  />
) : (
  <img
    src={`https://cdn.jsdelivr.net/gh/vadimmalykhin/binance-icons/crypto/${el.Subtitle.slice(
      1,
      4
    ).toLowerCase()}.svg`}
    alt="icon"
    onError={handleImgError}
    style={{
      width: '32px',
      height: '32px',
      borderRadius: '50%',
    }}
  />
)}

                        {account?.AccountCurrency == "EUR"
                          ? el.Subtitle.slice(1, -1).replace("/USD", "/EUR")
                          : el.Subtitle.slice(1, -1)}
                      </div>
                      <div className={styles.right_side}>
                        <span className={styles.leverage}>x{el.Leverage}</span>
                        <span
                          className={`${styles.type} ${
                            el.Status?.includes("BUY")
                              ? styles.buy
                              : el.Status?.includes("SELL")
                              ? styles.sell
                              : styles.simulate
                          }`}
                        >
                          {el.Status?.includes("D")
                            ? (
                                el.Status?.slice(0, 1) +
                                el.Status?.slice(1).toLowerCase()
                              ).slice(0, -1)
                            : el.Status?.slice(0, 1) +
                              el.Status?.slice(1).toLowerCase()}
                        </span>
                      </div>
                    </div>
                    <hr />
                    <div className={styles.account_amount}>
                      <div
                        className={styles.account}
                        onClick={toggleOrderDrawer(true, el)}
                      >
                        <label htmlFor="">{t("TP/SL")}</label>
                        <p className={styles.profit_loss}>
                          <span className={styles.take_profit}>
                            {account?.AccountCurrency == "EUR" ? "€ " : "$ "}
                            {el.TakeProfit
                              ? parseFloat(el.TakeProfit) > 1
                                ? el.TakeProfit?.toFixed(2)
                                : el.TakeProfit?.toFixed(5)
                              : " 0"}
                          </span>
                          /
                          <span className={styles.stop_loss}>
                            {account?.AccountCurrency == "EUR" ? "€ " : "$ "}
                            {el.StopLoss
                              ? parseFloat(el.StopLoss) > 1
                                ? el.StopLoss?.toFixed(2)
                                : el.StopLoss?.toFixed(5)
                              : " 0"}
                          </span>
                        </p>
                      </div>
                      <div
                        className={styles.account}
                        style={{ alignItems: "end" }}
                      >
                        <button
                          onClick={() => {
                            Sell(el);
                          }}
                          style={
                            el.Status === "BUY"
                              ? parseFloat(el.Profit) > 0
                                ? {
                                    cursor: "pointer",
                                    background: "none",
                                    border: "1px solid #4C47A2",
                                    color: "#4C47A2",
                                    padding: "8px 12px",
                                    borderRadius: "4px",
                                  }
                                : {
                                    cursor: "pointer",
                                    background: "none",
                                    border: "1px solid #00B4A0",
                                    color: "#00B4A0",
                                    padding: "8px 12px",
                                    borderRadius: "4px",
                                  }
                              : parseFloat(el.Profit) * -1 > 0
                              ? {
                                  cursor: "pointer",
                                  background: "none",
                                  border: "1px solid #4C47A2",
                                  color: "#4C47A2",
                                  padding: "8px 12px",
                                  borderRadius: "4px",
                                }
                              : {
                                  cursor: "pointer",
                                  background: "none",
                                  border: "1px solid #00B4A0",
                                  color: "#00B4A0",
                                  padding: "8px 12px",
                                  borderRadius: "4px",
                                }
                          }
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {selectedMobileTab === "open" && (
              <div className={styles.transactions_list}>
                {currentRecordsT?.map((el) => (
                  <div className={styles.transaction} key={el.Id}>
                    <div
                      className={styles.type_status}
                      onClick={toggleOrderDrawer(true, el)}
                    >
                      <div className={`${styles.left_side}`}>
                      {assetsLogo[AssetsList?.find(val=>val.Title === el.Title)?.Ticker]  ? (
  <div
    dangerouslySetInnerHTML={{ __html: assetsLogo[AssetsList?.find(val=>val.Title === el.Title)?.Ticker]  }}
    style={{
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      overflow: 'hidden',
    }}
  />
) : (
  <img
    src={`https://cdn.jsdelivr.net/gh/vadimmalykhin/binance-icons/crypto/${el.Subtitle.slice(
      1,
      4
    ).toLowerCase()}.svg`}
    alt="icon"
    onError={handleImgError}
    style={{
      width: '32px',
      height: '32px',
      borderRadius: '50%',
    }}
  />
)}

                        {account?.AccountCurrency == "EUR"
                          ? el.Subtitle.slice(1, -1).replace("/USD", "/EUR")
                          : el.Subtitle.slice(1, -1)}
                      </div>
                      <div className={styles.right_side}>
                        <span
                          className={`${styles.type} ${
                            el.Status?.includes("BUY") ? styles.buy : ""
                          }`}
                        >
                          {el.Status}
                        </span>
                        <span className={styles.leverage}>x{el.Leverage}</span>
                      </div>
                    </div>
                    <hr />
                    <div className={styles.account_amount}>
                      <div
                        className={styles.account}
                        onClick={toggleOrderDrawer(true, el)}
                      >
                        <label htmlFor="">{t("Amount")}</label>
                        <p>
                          {account?.AccountCurrency == "EUR" ? "€" : "$"}
                          {el.Price}
                        </p>
                      </div>
                      <div
                        className={styles.account}
                        style={{ alignItems: "end" }}
                      >
                        <button
                          onClick={() => {
                            Close(el);
                          }}
                          style={
                            el.Status === "BUY"
                              ? parseFloat(el.Profit) > 0
                                ? {
                                    cursor: "pointer",
                                    background: "none",
                                    border: "1px solid #4C47A2",
                                    color: "#4C47A2",
                                    padding: "8px 12px",
                                    borderRadius: "4px",
                                  }
                                : {
                                    cursor: "pointer",
                                    background: "none",
                                    border: "1px solid #00B4A0",
                                    color: "#00B4A0",
                                    padding: "8px 12px",
                                    borderRadius: "4px",
                                  }
                              : parseFloat(el.Profit) * -1 > 0
                              ? {
                                  cursor: "pointer",
                                  background: "none",
                                  border: "1px solid #4C47A2",
                                  color: "#4C47A2",
                                  padding: "8px 12px",
                                  borderRadius: "4px",
                                }
                              : {
                                  cursor: "pointer",
                                  background: "none",
                                  border: "1px solid #00B4A0",
                                  color: "#00B4A0",
                                  padding: "8px 12px",
                                  borderRadius: "4px",
                                }
                          }
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : null}
        <div
          className={styles.block_graph}
          id="graph_container"
          style={
            selectedTradingTab === "orders" && window.innerWidth < 1501
              ? { display: "none" }
              : {}
          }
        >
          <Graph
            active={activeAsset?.Title}
            interval={interval}
            intervalLabel={intervalLabel}
            activeType={activeAsset?.Type}
            usdToEur={usdToEur}
            eurToUsd={eurToUsd}
            theme={theme}
            ticker={activeAsset?.Ticker}
          />
          <div
            className={styles.buy_sell}
            style={{ display: window.innerWidth >= 1501 ? "flex" : "none" }}
          >
            <button onClick={toggleDrawer(true, "sell")}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
              >
                <path
                  d="M13.1667 7.33337L8.50004 11.3334L3.83337 7.33337"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.1667 4.66663L8.50004 8.66663L3.83337 4.66663"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>{t("Sell")}</span>
            </button>
            <button onClick={toggleDrawer(true, "buy")}>
              <span>{t("Buy")}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M12.6667 8.66663L8.00004 4.66663L3.33337 8.66663"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.6667 11.3334L8.00004 7.33337L3.33337 11.3334"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className={styles.orders_main_block}>
        <div className={styles.orders_header}>
          <div className={styles.leftSide}>
            <div
              className={
                !ordersOpened
                  ? styles.ordersOpenButton
                  : styles.ordersCloseButton
              }
              onClick={() => setOrdersOpened(!ordersOpened)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                viewBox="0 0 512 512"
              >
                <path
                  fill="#fff"
                  d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM385 215c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71L280 392c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-214.1-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 103c9.4-9.4 24.6-9.4 33.9 0L385 215z"
                />
              </svg>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M10.6667 2.66797C12.1167 2.67604 12.902 2.74034 13.4142 3.2526C14 3.83838 14 4.78119 14 6.66681V10.6668C14 12.5524 14 13.4952 13.4142 14.081C12.8284 14.6668 11.8856 14.6668 10 14.6668H6C4.11438 14.6668 3.17157 14.6668 2.58579 14.081C2 13.4952 2 12.5524 2 10.6668V6.66681C2 4.78119 2 3.83838 2.58579 3.2526C3.09804 2.74034 3.88332 2.67604 5.33333 2.66797"
                stroke="white"
                strokeWidth="1.5"
              />
              <path
                d="M4.66667 9.6665H10"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M4.66667 12H8.33334"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M5.33333 2.3335C5.33333 1.78121 5.78104 1.3335 6.33333 1.3335H9.66666C10.2189 1.3335 10.6667 1.78121 10.6667 2.3335V3.00016C10.6667 3.55245 10.2189 4.00016 9.66666 4.00016H6.33333C5.78104 4.00016 5.33333 3.55245 5.33333 3.00016V2.3335Z"
                stroke="white"
                strokeWidth="1.5"
              />
            </svg>
            <span>{t("Orders")}</span>
            <div>{currentRecordsT?.length}</div>
          </div>
          <div className={styles.rightSide}>
            <div className={styles.tabs}>
              <button
                ref={open}
                className={`${styles.orderDrawerButton} ${
                  selectedTab === "open" ? styles.active : ""
                }`}
                onClick={() => handleTabTableChange("open")}
              >
                {t("Open Orders")}
              </button>
              <button
                ref={deferred}
                className={`${styles.orderDrawerButton} ${
                  selectedTab === "deferred" ? styles.active : ""
                }`}
                onClick={() => handleTabTableChange("deferred")}
              >
                {t("Deferred Orders")}
              </button>
              <button
                ref={close}
                className={`${styles.orderDrawerButton} ${
                  selectedTab === "close" ? styles.active : ""
                }`}
                onClick={() => handleTabTableChange("close")}
              >
                {t("History")}
              </button>
            </div>
          </div>
        </div>
        {ordersOpened && (
          <div className={styles.orders_block}>
            <div className={styles.orders_content}>
              <div className={styles.table} style={{ width: "100%" }}>
                {selectedTab == "open" && (
                  <OrdersTable
                    key={AssetsList.length}
                    data={currentRecordsT}
                    columns={columns}
                    theme={theme}
                  />
                )}
                {selectedTab == "deferred" && (
                  <OrdersTable
                    key={AssetsList.length}
                    data={currentRecordsTD}
                    columns={columnsDeferred}
                    theme={theme}
                  />
                )}
                {selectedTab == "close" && (
                  <OrdersTable
                    key={AssetsList.length}
                    data={historyT}
                    columns={columnsClosed}
                    theme={theme}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      {/* <Drawer
        open={orderButtonIsPressed}
        anchor="bottom"
        onClose={handlePressButton}
        className={styles.orderDrawer}
      >
        <div className={styles.orders_header}>
          <div className={styles.leftSide}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M10.6667 2.66797C12.1167 2.67604 12.902 2.74034 13.4142 3.2526C14 3.83838 14 4.78119 14 6.66681V10.6668C14 12.5524 14 13.4952 13.4142 14.081C12.8284 14.6668 11.8856 14.6668 10 14.6668H6C4.11438 14.6668 3.17157 14.6668 2.58579 14.081C2 13.4952 2 12.5524 2 10.6668V6.66681C2 4.78119 2 3.83838 2.58579 3.2526C3.09804 2.74034 3.88332 2.67604 5.33333 2.66797"
                stroke="white"
                strokeWidth="1.5"
              />
              <path
                d="M4.66667 9.6665H10"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M4.66667 12H8.33334"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M5.33333 2.3335C5.33333 1.78121 5.78104 1.3335 6.33333 1.3335H9.66666C10.2189 1.3335 10.6667 1.78121 10.6667 2.3335V3.00016C10.6667 3.55245 10.2189 4.00016 9.66666 4.00016H6.33333C5.78104 4.00016 5.33333 3.55245 5.33333 3.00016V2.3335Z"
                stroke="white"
                strokeWidth="1.5"
              />
            </svg>
            <span>{t("Orders")}</span>
            <div>{currentRecordsT?.length}</div>
          </div>
          <div className={styles.rightSide}>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M1.33337 7.33333C1.33337 4.81918 1.33337 3.5621 2.11442 2.78105C2.89547 2 4.15255 2 6.66671 2H9.33337C11.8475 2 13.1046 2 13.8857 2.78105C14.6667 3.5621 14.6667 4.81918 14.6667 7.33333V8.66667C14.6667 11.1808 14.6667 12.4379 13.8857 13.219C13.1046 14 11.8475 14 9.33337 14H6.66671C4.15255 14 2.89547 14 2.11442 13.219C1.33337 12.4379 1.33337 11.1808 1.33337 8.66667V7.33333Z"
                  stroke="white"
                  strokeWidth="1.5"
                />
                <path
                  d="M10 14L10 2"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div>
        </div>
        <div className={styles.orders_block}>
          <div className={styles.orders_content}>
            <div className={styles.tabs}>
              <div className={styles.background} style={backgroundTableStyle}>
                <button
                  ref={open}
                  className={`${styles.orderDrawerButton} ${
                    selectedTab === "open" ? styles.active : ""
                  }`}
                  onClick={() => handleTabTableChange("open")}
                >
                  {t("Open Orders")}
                </button>
                <button
                  ref={deferred}
                  className={`${styles.orderDrawerButton} ${
                    selectedTab === "deferred" ? styles.active : ""
                  }`}
                  onClick={() => handleTabTableChange("deferred")}
                >
                  {t("Deferred Orders")}
                </button>
                <button
                  ref={close}
                  className={`${styles.orderDrawerButton} ${
                    selectedTab === "close" ? styles.active : ""
                  }`}
                  onClick={() => handleTabTableChange("close")}
                >
                  {t("History")}
                </button>
              </div>
            </div>
            <div className={styles.table} style={{ width: "100%" }}>
              {selectedTab == "open" && (
                <OrdersTable
                  key={AssetsList.length}
                  data={currentRecordsT}
                  columns={columns}
                  theme={theme}
                />
              )}
              {selectedTab == "deferred" && (
                <OrdersTable
                  key={AssetsList.length}
                  data={currentRecordsTD}
                  columns={columnsDeferred}
                  theme={theme}
                />
              )}
              {selectedTab == "close" && (
                <OrdersTableHistory
                  key={AssetsList.length}
                  data={historyT}
                  columns={columnsClosed}
                  theme={theme}
                />
              )}
            </div>
          </div>
        </div>
      </Drawer> */}
      {/* <button className={styles.orderButton} onClick={handlePressButton}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M10.6667 2.66785C12.1167 2.67592 12.902 2.74022 13.4142 3.25247C14 3.83826 14 4.78107 14 6.66669V10.6667C14 12.5523 14 13.4951 13.4142 14.0809C12.8284 14.6667 11.8856 14.6667 10 14.6667H6C4.11438 14.6667 3.17157 14.6667 2.58579 14.0809C2 13.4951 2 12.5523 2 10.6667V6.66669C2 4.78107 2 3.83826 2.58579 3.25247C3.09804 2.74022 3.88332 2.67592 5.33333 2.66785"
            stroke="white"
            strokeWidth="1.5"
          />
          <path
            d="M4.66667 9.66663H10"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M4.66667 12H8.33334"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M5.33333 2.33337C5.33333 1.78109 5.78104 1.33337 6.33333 1.33337H9.66666C10.2189 1.33337 10.6667 1.78109 10.6667 2.33337V3.00004C10.6667 3.55233 10.2189 4.00004 9.66666 4.00004H6.33333C5.78104 4.00004 5.33333 3.55233 5.33333 3.00004V2.33337Z"
            stroke="white"
            strokeWidth="1.5"
          />
        </svg>
        <span>{t("Orders")}</span>
        <div>{currentRecordsT?.length}</div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M1.33334 7.33333C1.33334 4.81918 1.33334 3.5621 2.11439 2.78105C2.89544 2 4.15252 2 6.66668 2H9.33334C11.8475 2 13.1046 2 13.8856 2.78105C14.6667 3.5621 14.6667 4.81918 14.6667 7.33333V8.66667C14.6667 11.1808 14.6667 12.4379 13.8856 13.219C13.1046 14 11.8475 14 9.33334 14H6.66668C4.15252 14 2.89544 14 2.11439 13.219C1.33334 12.4379 1.33334 11.1808 1.33334 8.66667V7.33333Z"
            stroke="white"
            strokeWidth="1.5"
          />
          <path
            d="M10 14L10 2"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </button> */}
      <EditOrderDrawer
        currentRecords={currentRecords}
        currentRow={currentRow}
        active={activeAsset}
        activePrice={activePrice}
        eurToUsd={eurToUsd}
        usdToEur={usdToEur}
        open={openEditDrawer}
        theme={theme}
        toggleDrawer={toggleEditDrawer}
        buyOrder={buyOrder}
        sellOrder={sellOrder}
        backgroundOrderStyle={backgroundOrderStyle}
        handleTabOrderChange={handleTabOrderChange}
        selectedOrderTab={selectedOrderTab}
        account={account}
        setSnackMessage={setSnackMessage}
        setSnackType={setSnackType}
        handleClick={handleClick}
      />
      <BuySellDrawer
        applications={applications}
        active={activeAsset}
        activePrice={activePrice}
        eurToUsd={eurToUsd}
        usdToEur={usdToEur}
        open={openDrawer}
        theme={theme}
        toggleDrawer={toggleDrawer}
        buyOrder={buyOrder}
        sellOrder={sellOrder}
        backgroundOrderStyle={backgroundOrderStyle}
        handleTabOrderChange={handleTabOrderChange}
        selectedOrderTab={selectedOrderTab}
        account={account}
        setSnackMessage={setSnackMessage}
        setSnackType={setSnackType}
        handleClick={handleClick}
      />
      <MobileAssetsDrawer
        open={openAssetsDrawer}
        toggleDrawer={toggleAssetsDrawer}
        theme={theme}
        currentRecords={currentRecords}
        favorites={favorites}
        toggleFavorite={toggleFavorite}
        setActiveAsset={setActiveAsset}
        setActivePrice={setActivePrice}
        activeAsset={activeAsset}
        account={account}
        eurToUsd={eurToUsd}
        setSnackMessage={setSnackMessage}
        setSnackType={setSnackType}
        handleClick={handleClick}
      />

      {/* <AssetsListComponent
        theme={theme}
        openDrawerAssets={openDrawerAssets}
        toggleDrawer={toggleDrawerAssets}
        currentRecords={currentAssets}
        setActivePrice={setActivePrice}
        activePrice={activePrice}
        favorites={favorites}
        toggleFavorite={toggleFavorite}
        setActiveAsset={setActiveAsset}
        activeAsset={activeAsset}
        eurToUsd={eurToUsd}
        usdToEur={usdToEur}
        account={account}
        setSnackMessage={setSnackMessage}
        setSnackType={setSnackType}
        handleClick={handleClick}
      /> */}
      <MobileOrderDrawer
        currentRecords={currentRecords}
        theme={theme}
        account={account}
        open={openOrderDrawer}
        eurToUsd={eurToUsd}
        toggleDrawer={toggleOrderDrawer}
        activeOrder={activeOrder}
        marketPrice={activeOrder?.MarketPrice}
        AssetsList={AssetsList}
      />
    </div>
  );
}
